var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalDelivery = function SvgExternalDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.625H5.85L4.38 8.667h6.12V4.625Zm1.458 5.042H1.875v7.25H3.67a2.793 2.793 0 0 1 5.494 0h3.672a2.793 2.793 0 0 1 5.494 0h1.795v-7.25h-8.167Zm-8.288 8.25H.875v-9.25h2.441L5.03 3.954l.12-.329H16.838l.126.314 1.834 4.584.057.144h2.27v9.25H18.33a2.792 2.792 0 0 1-5.494 0H9.164a2.793 2.793 0 0 1-5.494 0Zm14.108-9.25-1.616-4.042H11.5v4.042h6.278ZM6.417 15.625a1.792 1.792 0 1 0 0 3.584 1.792 1.792 0 0 0 0-3.584Zm9.166 0a1.792 1.792 0 1 0 0 3.583 1.792 1.792 0 0 0 0-3.583Z",
    fill: "#fff"
  })));
};
export default SvgExternalDelivery;